
import { dynamicImportWithRetry } from "@fatso83/retry-dynamic-import"

import MultiDevice from "app/multi_device/index"
import {
  captureException,
} from "app/error_reporting"

import {
  performance,
} from "plugins/user-timing-polyfill"

const init = () => {
  performance.mark("spacious_mark__before_page_init")
  if (MultiDevice.Page.isForMobile()) {
    dynamicImportWithRetry(() => import("./mobile_ver/index"))
    .then((module) => {
      module?.default?.init?.()

      performance.mark("spacious_mark__after_page_init")
      performance.measure(
        "spacious_measure__page_init",
        "spacious_mark__before_page_init",
        "spacious_mark__after_page_init",
      )
    })
    .catch((error) => {
      captureException(error)
    })
  }
  else {
    dynamicImportWithRetry(() => import("./desktop_ver/index"))
    .then((module) => {
      module?.default?.init?.()

      performance.mark("spacious_mark__after_page_init")
      performance.measure(
        "spacious_measure__page_init",
        "spacious_mark__before_page_init",
        "spacious_mark__after_page_init",
      )
    })
    .catch((error) => {
      captureException(error)
    })
  }
}

export default {
  init: init,
}
